module.exports = __webpack_public_path__ + "static/media/tree_9.71cee0d3.jpg";